import { render, staticRenderFns } from "./ListBuyerCampaigns.vue?vue&type=template&id=5916b601&scoped=true"
import script from "./ListBuyerCampaigns.vue?vue&type=script&lang=js"
export * from "./ListBuyerCampaigns.vue?vue&type=script&lang=js"
import style0 from "./ListBuyerCampaigns.vue?vue&type=style&index=0&id=5916b601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916b601",
  null
  
)

export default component.exports